import React, { useState } from 'react';
import { Building, MapPin, Calendar } from 'lucide-react';

const projectsData = [
  {
    id: 1,
    title: 'Topographic Survey for NH-38 & NH-44 Highway Sections',
    client: 'FP India Project Management Consultancy Services Pvt. Ltd. (Mumbai)',
    category: 'NHAI & Highways',
    location: 'NH-38 (Madurai-Tuticorin) & NH-44 (Karur-Dindigul) & Oddanchatram Bypass',
    period: '2023 - 2026',
    image: '/survey_topo.png',
    scope: 'Topographical survey for NH-38 section for VUP (CH 164.500), LVUP (CH 207.150 & 231.600), NH-44 Karur-Dindigul section (Ch. 319.170 to 321.170), and Oddanchatram Bypass (Ch 33.200). Ref: FPPMC/TT/235026 & 235011.',
    tag: 'FP India PMC (NHAI)'
  },
  {
    id: 2,
    title: '10+ High-Level Bridges & Road Alignment Drawings',
    client: 'Highways Department (Govt. of Tamil Nadu)',
    category: 'Government & DPR',
    location: 'Srivilliputhur, Devakottai, SH-27, Sivagangai & Pan-TN',
    period: '2022 - 2026',
    image: '/bridge_road_alignment.jpg',
    scope: 'Preparation of alignment and survey drawings for 10+ high-level bridges: Srivilliputhur-Parthibanur (Km 1/2), Oyyavandhan-Kanjipatti (Km 5/8), Satharasankottai-Sooranam (Km 10/10 & 10/6), Devakottai border (Km 12/4), SH-27 Eraniyur (Km 2/4), Nerkuppai (Km 1/10), NH-210 Anandhur (Km 10/6), and Sundavilai (Km 3/10).',
    tag: 'Govt. Highways Dept.'
  },
  {
    id: 3,
    title: 'Chittoor-Tiruttani & SH-50A Road Widening & Tank DPR',
    client: 'AST Construction',
    category: 'Government & DPR',
    location: 'Theni District & Chittoor-Tiruttani Corridor',
    period: '2023 - 2025',
    image: '/surveyor_water_work.jpg',
    scope: 'Level & quantity checking for 2-to-4 lane widening on Chittoor-Tiruttani Rd (Km 16/0-22/0) & Korattur-Periyapalayam SH-50A (Km 7/0-18/4). DPR preparation for Ponrajakulam Tank deepening (Odaipatti, Theni Dt) and Giri Vallam Road in Oddanchatram.',
    tag: 'AST 4-Lane & Tank DPR'
  },
  {
    id: 4,
    title: '100 MW Solar Power Plant Survey & Pile Marking',
    client: 'Vel Engineering Service, Karur',
    category: 'Solar & Industrial',
    location: 'Trichy Region, TN',
    period: '2024 - 2025',
    image: '/foif_a90_park.jpg',
    scope: 'Land purchasing boundary verification, FOIF A-90 DGPS coordinate locking, and precision pile marking for a 100 MW solar power production project near Trichy.',
    tag: '100 MW Solar Project'
  },
  {
    id: 5,
    title: 'BIG TECH Industrial Site Preparation (TATA Project)',
    client: 'ARC Construction (under TATA)',
    category: 'Solar & Industrial',
    location: 'Pillaipakkam Industrial Hub, TN',
    period: '2024',
    image: '/survey_cad.png',
    scope: 'Consulting & quantity checking for major industrial site preparation in Pillaipakkam for BIG TECH with ARC Construction under TATA.',
    tag: 'TATA Pillaipakkam'
  },
  {
    id: 6,
    title: 'Mudukulathur Bypass Alignment Phase I & Phase II',
    client: 'Siva Siva Construction',
    category: 'NHAI & Highways',
    location: 'Mudukulathur Bypass Corridor, TN',
    period: '2024 - 2026',
    image: '/dgps_plot.jpg',
    scope: 'Consulting & quantity checking for road alignment preparation of Mudukulathur Bypass Phase I (Completed) and Phase II (Under Process).',
    tag: 'Bypass Alignment'
  },
  {
    id: 7,
    title: 'Major Estate Land Boundary Surveys (G-Square & Large Parcels)',
    client: 'G-Square & Private Estate Developers',
    category: 'Major Boundary Surveys',
    location: 'Kodaikanal (100 Acres), Sirumalai (40 Acres), Cumbum (28 Acres)',
    period: '2023 - 2026',
    image: '/surveyor_hill.jpg',
    scope: 'Completed 100 Acres land boundary survey near Kodaikanal, 40 Acres boundary survey near Sirumalai, and 28 Acres boundary survey near Cumbum for G-Square using dual FOIF A-90 DGPS systems.',
    tag: '100+ Acre DGPS Boundary'
  }
];

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState('All');

  const categories = ['All', 'NHAI & Highways', 'Government & DPR', 'Solar & Industrial', 'Major Boundary Surveys'];

  const filteredProjects = activeFilter === 'All'
    ? projectsData
    : projectsData.filter(p => p.category === activeFilter);

  return (
    <section id="projects" className="section-padding" style={{ position: 'relative', background: '#ffffff' }}>
      <div className="container">
        {/* Section Header */}
        <div className="section-title-wrapper">
          <div className="section-subtitle">Proven Track Record</div>
          <h2 className="section-title">
            Featured <span className="gradient-text">Project Gallery</span>
          </h2>
          <p className="section-desc">
            Demonstrated excellence in Water Resources Development (W.R.D) work, high-accuracy DGPS surveys, and digital land consulting across Tamil Nadu.
          </p>
        </div>

        {/* Category Filters */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '0.75rem',
            marginBottom: '3rem',
          }}
        >
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveFilter(cat)}
              style={{
                padding: '0.65rem 1.4rem',
                borderRadius: 'var(--radius-full)',
                border: activeFilter === cat ? '1px solid #e63946' : '1px solid #cbd5e1',
                background: activeFilter === cat ? '#fff5f5' : '#ffffff',
                color: activeFilter === cat ? '#e63946' : '#475569',
                fontFamily: 'var(--font-heading)',
                fontSize: '0.875rem',
                fontWeight: '700',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Project Grid */}
        <div className="grid-2" style={{ gap: '2rem' }}>
          {filteredProjects.map((proj) => (
            <div
              key={proj.id}
              className="glass-card"
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                background: '#ffffff',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                borderRadius: '16px',
                overflow: 'hidden',
              }}
            >
              {/* Project Image Header */}
              <div style={{ height: '180px', position: 'relative', overflow: 'hidden' }}>
                <img src={proj.image} alt={proj.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(15,23,42,0.6) 0%, transparent 60%)' }} />
                <div style={{ position: 'absolute', top: '1rem', left: '1rem' }}>
                  <span className="badge badge-gold" style={{ fontSize: '0.75rem', background: 'rgba(255,255,255,0.9)', backdropFilter: 'blur(8px)', color: '#d97706' }}>
                    {proj.tag}
                  </span>
                </div>
                <div style={{ position: 'absolute', bottom: '0.85rem', right: '1rem', color: '#ffffff', fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: '0.3rem', fontWeight: '600' }}>
                  <Calendar size={13} /> {proj.period}
                </div>
              </div>

              <div style={{ padding: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div>
                  {/* Project Title */}
                  <h3 style={{ fontSize: '1.25rem', marginBottom: '0.6rem', color: '#0f172a', lineHeight: 1.3 }}>
                    {proj.title}
                  </h3>

                  {/* Client Name */}
                  <div style={{ fontSize: '0.9rem', fontWeight: '700', color: '#e63946', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                    <Building size={15} /> {proj.client}
                  </div>

                  {/* Scope Description */}
                  <p style={{ color: '#475569', fontSize: '0.925rem', lineHeight: 1.6, marginBottom: '1.5rem' }}>
                    {proj.scope}
                  </p>
                </div>

                {/* Location Footer */}
                <div
                  style={{
                    paddingTop: '1rem',
                    borderTop: '1px solid #e2e8f0',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    fontSize: '0.85rem',
                    color: '#475569',
                    fontWeight: '600',
                  }}
                >
                  <MapPin size={15} color="#0066ff" /> {proj.location}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
